import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useStyles } from './styles';
import Image from 'next/image';
import LazyLoad from 'react-lazyload';
import { useTranslation } from 'next-i18next';

export default function Templates() {
  const classes = useStyles();
  const { t } = useTranslation('pricing');

  return (
    <Box className={classes.boxFeatures}>
      <LazyLoad>
        <Container>
          <span className={classes.tagPage}>{t('templates.tag')}</span>
          <Typography
            className={classes.titleHero}
            component="h2"
            dangerouslySetInnerHTML={{ __html: t('templates.title') }}
          />

          <Typography className={classes.subtitle} component="p">
            {t('templates.subtitle')}
          </Typography>

          <Image
            src="/images/pricing/templates-image.png"
            width={1173}
            height={764}
            alt="Templates Images"
            loading="lazy"
          />

          <Box textAlign="center" mt={4.75} className={classes.boxButton}>
            <Button className={classes.button} variant="outlined" href="#plans-list">
              <b>{t('templates.button')}</b>
            </Button>
          </Box>
        </Container>
      </LazyLoad>
    </Box>
  );
}
